import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './breadcrumb.component.html',
  styles: [],
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumbs: any = [];
  eventService = inject(EventService);
  theme = computed(() => this.eventService.theme());

  ngOnInit(): void {
  }

  getClassBreadCrumb(active: boolean): string {
    const textClass = this.theme() === 'dark' ? 'text-white' : 'text-black';
    if (active) {
      return 'breadcrumb-item ' + textClass;
    } else {

      return 'breadcrumb-item active';
    }
  }
}
